import { useContext } from 'react'
import { useSearchParams } from 'react-router-dom'

import AppContext from '@/context/AppContext'

const useRefundType = () => {
  const [searchParams] = useSearchParams()
  const { context } = useContext(AppContext)

  /**
   * @returns {String} "bank_transfer", "store_credit" or "original_payment_method"
   */
  const getRefundType = () => {
    return searchParams.get('refundType') || context.orderInfo.refundType
  }

  return { getRefundType }
}

export default useRefundType
